/** @format */

// App Store URLs
export const APP_STORE_URLS = {
  APPLE_APP_STORE: "https://apps.apple.com/us/app/eon-health/id6451053065",
  GOOGLE_PLAY_STORE:
    "https://play.google.com/store/apps/details?id=com.eonhealth",
} as const;

// Store types for analytics
export const STORE_TYPES = {
  APPLE: "apple_app_store",
  GOOGLE: "google_play_store",
} as const;
